/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";

export const KillswitchConflictName = {
  OperationConflict: "operation_conflict",
  VersionConflict: "version_conflict",
} as const;
export type KillswitchConflictName = OpenEnum<typeof KillswitchConflictName>;

/** @internal */
export const KillswitchConflictName$inboundSchema: z.ZodMiniType<
  KillswitchConflictName,
  unknown
> = openEnums.inboundSchema(KillswitchConflictName);
